import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  horizontalView: {
    backgroundColor: theme.palette.background.paper,
    margin: 16,
    paddingLeft: 0,
    paddingRight: 0,
    '& .makeStyles-tabContent-79': {
      border: 'none',
    },
  },
  root: {
    display: 'flex',
    alignItems: 'stretch',
  },
  media: {
    width: '50%',
    position: 'relative',
    height: '100%',
  },
  title: {
    cursor: 'pointer',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
    padding: theme.spacing(2),
    width: '50%',
    height: 'auto',
    '& h2': {
      fontSize: 24,
    },
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 'auto',
    paddingTop: theme.spacing(1),
  },
}));
